// import Vue from 'vue'
import Router from 'vue-router'
var width = $(window).width()
Vue.use(Router)
const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        title: '二甲双胍1'
      },
      component: (resolve) => {
        import('@components/Tbmobile.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbmobile',
      name: 'Tbmobile',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbmobile.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/medbox',
      name: 'MedBox',
      meta: {
        title: '家庭药盒'
      },
      component: (resolve) => {
        import('@components/MedBox.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/userbind',
      name: 'UserBind',
      meta: {
        title: '用户绑定'
      },
      component: (resolve) => {
        import('@components/UserBind.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/mydoc',
      name: 'MyDoc',
      meta: {
        title: '我的医生'
      },
      component: (resolve) => {
        import('@components/MyDoc.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/toorigins',
      name: 'ToOrigins',
      meta: {
        title: '药品溯源'
      },
      component: (resolve) => {
        import('@components/ToOrigins.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/wine',
      name: 'Wine',
      meta: {
        title: '十大名酒'
      },
      component: (resolve) => {
        import('@components/Wine.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/thingsDetail',
      name: 'ThingsDetail',
      meta: {
        title: '商品详情'
      },
      component: (resolve) => {
        import('@components/ThingsDetail.vue').then((module) => {
          resolve(module)
        })
      }
    }

  ]
})

/**
 *@date: 2018-09-04 10:17:38
 *@author:
 *@desc: 路由全局钩子函数，可以做路由跳转拦截
 */
router.beforeEach((to, from, next) => {
  console.log('路由拦截')
  console.log(to.name)
  console.log(from.name)
  console.log(to.meta.title)
  // if (to.meta.title) document.title = `${to.meta.title}`
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js